import { render, staticRenderFns } from "./AuthResetPasswordSetPassword.vue?vue&type=template&id=555fea82&scoped=true&"
import script from "./AuthResetPasswordSetPassword.vue?vue&type=script&lang=js&"
export * from "./AuthResetPasswordSetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555fea82",
  null
  
)

export default component.exports